export const getPrivateSpaceSlide = ({privateSpaces = [], sharedSpaces = []}) => {
  const privateSpacesLength = privateSpaces?.length;
  const sharedSpacesLength = sharedSpaces?.length;
  let maxPrivatLength = privateSpacesLength > 5 ? 5 : privateSpacesLength;
  let maxsharedLength = sharedSpacesLength > 5 ? 5 : sharedSpacesLength;
  if (privateSpacesLength > 3) {
    maxsharedLength = Math.min(2, maxsharedLength);
    maxPrivatLength = Math.min(maxPrivatLength, 5 - maxsharedLength);
  } else {
    maxsharedLength = Math.min(maxsharedLength, 5 - maxPrivatLength);
    maxPrivatLength = Math.min(maxPrivatLength, 5 - maxsharedLength);
  }
  return {
    maxPrivatLength: 21.3 * maxPrivatLength + 3,
    maxSharedLength: 21.3 * maxsharedLength + 3,
  };
};
